import { render, staticRenderFns } from "./PhraseCountCell.vue?vue&type=template&id=31d3e896&scoped=true"
import script from "./PhraseCountCell.vue?vue&type=script&lang=js"
export * from "./PhraseCountCell.vue?vue&type=script&lang=js"
import style0 from "./PhraseCountCell.vue?vue&type=style&index=0&id=31d3e896&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3e896",
  null
  
)

export default component.exports